module.exports = __webpack_public_path__ + "static/media/ic_alerta.ffd194bb.svg";